import { useState } from 'react';
import Modal, { ModalButton } from './Modal';
import { dmApi } from './format';

const CATEGORIES = [
  { id: 'spam', label: 'Spam' },
  { id: 'harassment', label: 'Harassment or hate' },
  { id: 'other', label: 'Something else' },
];

// Report a message (with the messages before it as context) or a user to the BLOBL moderators
export default function ReportDialog({ messageId, userId, name, onClose }) {
  const [category, setCategory] = useState(null);
  const [reason, setReason] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | sent | error

  const submit = async () => {
    setState('sending');
    try {
      if (messageId) await dmApi.post('/api/reports/message', { message_id: messageId, category, reason });
      else await dmApi.post('/api/reports/user', { user_id: userId, category, reason });
      setState('sent');
    } catch {
      setState('error');
    }
  };

  if (state === 'sent') {
    return (
      <Modal title="Thanks for reporting" onClose={onClose} footer={<ModalButton primary onClick={onClose}>Done</ModalButton>}>
        <p className="m-0 text-sm leading-relaxed text-text-muted">
          The moderators will review it. You can also block {name || 'this user'} so they can't message you anymore.
        </p>
      </Modal>
    );
  }

  return (
    <Modal
      title={messageId ? 'Report message' : `Report ${name || 'user'}`}
      onClose={onClose}
      footer={<>
        <ModalButton onClick={onClose}>Cancel</ModalButton>
        <ModalButton danger disabled={!category || state === 'sending'} onClick={submit}>
          {state === 'sending' ? 'Sending…' : 'Report'}
        </ModalButton>
      </>}
    >
      <p className="mb-3 mt-0 text-[13px] leading-relaxed text-text-dim">
        {messageId
          ? 'The message, its files and up to 10 messages before it are sent to the moderators. They are kept until the report is closed.'
          : 'Tell the moderators what is wrong.'}
      </p>
      <div className="mb-3 flex flex-col gap-1.5">
        {CATEGORIES.map(c => (
          <label
            key={c.id}
            className={`flex cursor-pointer items-center gap-3 rounded-sm border border-solid px-3 py-2.5 text-sm ${
              category === c.id ? 'border-purple bg-purple-glow text-text' : 'border-border text-text-muted hover:bg-surface-3'
            }`}
          >
            <input type="radio" name="report-category" checked={category === c.id} onChange={() => setCategory(c.id)} className="accent-[#9b5de5]" />
            {c.label}
          </label>
        ))}
      </div>
      <textarea
        value={reason}
        onChange={e => setReason(e.target.value.slice(0, 500))}
        placeholder="Add details (optional)"
        rows={3}
        className="box-border w-full resize-none rounded-sm border border-solid border-border bg-surface-3 px-3 py-2 font-body text-sm text-text outline-none placeholder:text-text-dim focus:border-purple"
      />
      {state === 'error' && <div className="mt-2 text-xs text-red">Could not send the report. Please try again.</div>}
    </Modal>
  );
}
